import { useIntl } from 'react-intl'
import { NumberInput } from 'ui'
import { ShippingVariantSelector } from '../../../../../../ShippingVariantSelector'
import { SettingsProps } from '../../../hooks/useGenericComponent'
import { messages } from './messages'

export function PercentualShippingEditor(props: SettingsProps) {
  const { state } = props
  const { $t } = useIntl()

  return (
    <>
      <NumberInput
        name="value"
        state={state}
        aria-label={$t(messages.editor.ariaLabel)}
        helpText={$t(messages.editor.helpText)}
        suffix="%"
      />
      <ShippingVariantSelector state={state} />
    </>
  )
}
